// extracted by mini-css-extract-plugin
export default {"scale-box":"scale-box","selected":"selected","poor":"poor","good":"good","best":"best"};